import CustomStore from 'devextreme/data/custom_store';
import { createPackageProperty, deletePackageProperty, getPackageProperties, updatePackageProperty } from '../../api/packageProperties';

export const createPackagePropertiesStore = () => {
    const store = new CustomStore({
        key: 'id',
        loadMode: 'raw',
        // Share the same request between data, count and by-key lookups.
        load: getPackageProperties,
        insert: createPackageProperty,
        update: updatePackageProperty,
        remove: deletePackageProperty,
        // Clear before the grid reloads following a successful mutation.
        onModified: () => store.clearRawDataCache(),
    });
    return store;
};

export const packagePropertiesDataGrid = createPackagePropertiesStore();
